export const NO_TOKEN_ERROR_STATUS_CODE = 401;
export const NOT_AUTHORIZED_ERROR_STATUS_CODE = 403;
export const INVALID_PUBLIC_DISCOUNT_CODE_ERROR_NAME =
  "InvalidPublicDiscountCode";

export const INVALID_REFERRAL_CODE_ERROR_NAME = "InvalidReferralCode";
